import log$1 from 'loglevel';

const log = log$1.getLogger("torus.js");
log.disableAll();

export { log as default };
